import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { Select, type SelectProps } from '@wf/components';

import { getSelectOptionsFromStrArr } from '../../../../../../helpers/getSelectOptionsFromStrArr';
import { lpcoListStatuses, newRequestStatuses } from '../../../../configs';
import { licenseTableKeys } from '../../tableConfigs';

import styles from '../LicensesSearch.module.scss';

type StatusSelectType = SelectProps<SelectOption> & {
  isNewLicenses: boolean;
};

function StatusSelect({ onChange, defaultValue, isNewLicenses }: StatusSelectType) {
  const { t } = useTranslation();

  const statusSelectOptions = useMemo(
    () => getSelectOptionsFromStrArr(isNewLicenses ? newRequestStatuses : lpcoListStatuses, t),
    [isNewLicenses, t]
  );

  return (
    <Select
      placeholder={t('Choose a Status')}
      name={licenseTableKeys.status}
      options={statusSelectOptions}
      defaultValue={defaultValue}
      className={styles.input}
      onChange={onChange}
      isClearable
    />
  );
}

export default StatusSelect;
